import {
  getCaseStudies,
  CASE_STUDIES_CTA,
  CASE_STUDIES_PROCESS,
  CASE_STUDIES_SEO,
  CASE_STUDY_FILTER_KEY,
} from '@/data/caseStudies';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { CaseStudiesHero } from '@/components/site/casestudies/CaseStudiesHero';
import { FeaturedCaseStudy } from '@/components/site/casestudies/FeaturedCaseStudy';
import { CaseStudyExplorer } from '@/components/site/casestudies/CaseStudyExplorer';
import { OutcomeTypes } from '@/components/site/casestudies/OutcomeTypes';
import { CaseTestimonial } from '@/components/site/casestudies/CaseTestimonial';
import { ServiceDelivery } from '@/components/site/service/ServiceDelivery';
import { CtaBand } from '@/components/site/CtaBand';

// Build the enquiry href lazily at click time so an active category filter
// is carried into the enquiry journey where possible.
const discussHref = () => {
  const category = window.sessionStorage.getItem(CASE_STUDY_FILTER_KEY);
  const serviceParam = ['operations', 'people', 'growth', 'launch'].includes(category)
    ? `service=${category}&`
    : '';
  return `/?${serviceParam}source=Case%20Studies#solution-finder`;
};

export default function CaseStudiesPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: CASE_STUDIES_SEO.title,
    description: CASE_STUDIES_SEO.description,
    canonical: `${origin}/case-studies`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          name: CASE_STUDIES_SEO.title,
          description: CASE_STUDIES_SEO.description,
          url: `${origin}/case-studies`,
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
            { '@type': 'ListItem', position: 2, name: 'Case Studies', item: `${origin}/case-studies` },
          ],
        },
      ],
    },
  });

  // Referenced here so the collection remains the single source of truth.
  void getCaseStudies;

  return (
    <>
      <CaseStudiesHero />
      <FeaturedCaseStudy />
      <CaseStudyExplorer />
      <OutcomeTypes />
      <CaseTestimonial />
      <ServiceDelivery
        data={CASE_STUDIES_PROCESS}
        accent="#FFB800"
        index="05"
        testidPrefix="case-studies"
        sectionClass="bg-mist"
      />
      <CtaBand
        index={CASE_STUDIES_CTA.index}
        eyebrow={CASE_STUDIES_CTA.eyebrow}
        heading={CASE_STUDIES_CTA.heading}
        copy={CASE_STUDIES_CTA.copy}
        primaryLabel={CASE_STUDIES_CTA.primaryLabel}
        primaryHref={discussHref}
        secondaryLabel={CASE_STUDIES_CTA.secondaryLabel}
        secondaryHref={CASE_STUDIES_CTA.secondaryHref}
      />
    </>
  );
}
